import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { RequestFieldFilterInterface } from 'src/app/util/interfaces/request';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class RequestFieldFiltersService {
	postFiltersUrl = environment.baseApiUrl + 'register/user/filter';
	getRequestFieldFilter = environment.baseApiUrl + 'register/filter';
	getRequestSelectedFilters = environment.baseApiUrl + 'register/selectedFilters';
	deleteRequestFilters = environment.baseApiUrl + 'register/deleteSelectedFilters';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getFilterOptions(): Observable<RequestFieldFilterInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		return this.http.get<JSON[]>(this.getRequestFieldFilter, { headers: headers }).pipe(
			map((filter) => {
				const newFilter: RequestFieldFilterInterface[] = [];

				filter.forEach((element: any) => {
					const newFilterItem: RequestFieldFilterInterface = {
						id: element.id,
						name: element.name,
					};
					newFilter.push(newFilterItem);
				});

				return newFilter;
			})
		);
	}

	getSelectedFilters(): Observable<RequestFieldFilterInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		return this.http.get<JSON[]>(this.getRequestSelectedFilters, { headers: headers }).pipe(
			map((filter) => {
				const newFilter: RequestFieldFilterInterface[] = [];

				filter.forEach((element: any) => {
					const newFilterItem: RequestFieldFilterInterface = {
						selectedFilterEnduser: element.selectedFilterEnduser,
						selectedFilterAnalyst: element.selectedFilterAnalyst,
					};
					newFilter.push(newFilterItem);
				});

				return newFilter;
			})
		);
	}

	postFilter(filter: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.post(this.postFiltersUrl, filter, { headers: headers });
	}

	deleteFilters(): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.delete(this.deleteRequestFilters, { headers: headers });
	}
}
